import React from "react";
import { MessageBox } from "./MessageBox/MessageBox";
interface IErrorMessage {
    text: string;
}
export const ErrorMessage = ({ text }: IErrorMessage) => {
    return <MessageBox text={text} red />;
};
